module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep2@2x-7b161758b199b6f61de1676151fcee64.png";